import React from 'react';
import IndieChatFull from '../IndieChatFull';
import type { OrbitClient } from '../../../services/OrbitChatService';
import type { OrbitChatViewHandoff } from '../../../hooks/useOrbitChat';
import V3ChatLeftSidebar from './V3ChatLeftSidebar';
import V3ChatRightSidebar from './V3ChatRightSidebar';

interface V3IndieChatFullProps {
  title?: string;
  clientId?: number;
  client?: OrbitClient;
  initialConversationId?: string;
  initialPrompt?: string;
  initialHandoff?: OrbitChatViewHandoff;
  onConversationIdChange?: (conversationId?: string) => void;
  userName?: string;
}

/**
 * V3 owns its panel presentation while retaining the proven live Orbit
 * conversation, history, upload, feedback, action, and artifact behavior.
 */
const V3IndieChatFull: React.FC<V3IndieChatFullProps> = (props) => (
  <IndieChatFull
    {...props}
    leftSidebarComponent={V3ChatLeftSidebar}
    rightPanelComponent={V3ChatRightSidebar}
  />
);

export default V3IndieChatFull;
